// extracted by mini-css-extract-plugin
export default {"content":"First_content__JQSeC","container":"First_container__X8oEf"};